class CouponCode extends HTMLElement {
  constructor() {
    super();
    this.toast = null;
  }

  connectedCallback() {
    this.style.cursor = 'pointer';
    this.addEventListener('click', this.handleClick.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    if (this.toast) {
      this.toast.remove();
    }
  }

  async handleClick(e) {
    e.preventDefault();
    const couponCode = this.dataset.couponCode;

    if (!couponCode) {
      console.error('No coupon code found');
      return;
    }

    try {
      await navigator.clipboard.writeText(couponCode);
      this.showToast('Coupon code copied!');
    } catch (err) {
      console.error('Failed to copy coupon code:', err);
      // 降级方案：使用传统的复制方法
      this.fallbackCopy(couponCode);
    }
  }

  fallbackCopy(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    document.body.appendChild(textArea);
    textArea.select();

    try {
      document.execCommand('copy');
      this.showToast('Coupon code copied!');
    } catch (err) {
      console.error('Fallback copy failed:', err);
      this.showToast('Failed to copy', 'error');
    }

    document.body.removeChild(textArea);
  }

  showToast(message, type = 'success') {
    // 移除之前的 toast
    if (this.toast) {
      this.toast.remove();
    }

    // 创建 toast 元素
    this.toast = document.createElement('div');
    this.toast.className = `coupon-toast coupon-toast--${type}`;
    this.toast.textContent = message;

    document.body.appendChild(this.toast);

    // 触发动画
    requestAnimationFrame(() => {
      this.toast.classList.add('coupon-toast--show');
    });

    // 3秒后移除
    setTimeout(() => {
      if (this.toast) {
        this.toast.classList.remove('coupon-toast--show');
        setTimeout(() => {
          if (this.toast) {
            this.toast.remove();
            this.toast = null;
          }
        }, 300);
      }
    }, 3000);
  }
}

customElements.define('coupon-code', CouponCode);
